module.exports = __webpack_public_path__ + "img/P1.2887455.svg";